import api from './api';

class SettingVoucherService {
  getDataVouchers(dataForm) {
    return api.post('/merchant/vouchers', dataForm);
  }

  getDataVoucherBundle(dataForm) {
    return api.post('/merchant/vouchers-bundle', dataForm);
  }

  deleteVoucher(voucherId) {
    return api.post('/merchant/voucher/delete/' + voucherId);
  }

  changeStatus(voucherId) {
    return api.post('/merchant/voucher/change-status/' + voucherId);
  }

  bulkChangeStatus(dataForm) {
    return api.post('/merchant/voucher/bulk/change-status', dataForm);
  }

  changeStatusVoucherBundle(voucherId) {
    return api.post('/merchant/voucher-bundle/change-status/' + voucherId);
  }

  bulkChangeStatusVoucherBundle(dataForm) {
    return api.post('/merchant/voucher-bundle/bulk/change-status', dataForm);
  }

  createNewVoucher() {
    return api.post('/merchant/voucher');
  }

  createNewVoucherBundle() {
    return api.post('/merchant/voucher-bundle');
  }

  getDataVoucherDetail(voucherId) {
    return api.post('/merchant/voucher/' + voucherId);
  }

  getDataVoucherBundleDetail(voucherId) {
    return api.post('/merchant/voucher-bundle/' + voucherId);
  }

  addOrUpdateVoucher(dataForm) {
    return api.post('/merchant/voucher-create-or-update', dataForm, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  addOrUpdateVoucherBundle(dataForm) {
    return api.post('/merchant/voucher-bundle/create-or-update', dataForm, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  changeQuantity(dataForm) {
    return api.post('/merchant/voucher-change-quantity', dataForm);
  }

  voucherExchanged(dataForm) {
    return api.post('/merchant/voucher-exchanged', dataForm);
  }

  getFilterData(dataForm) {
    return api.post('/merchant/voucher-get-filter-data', dataForm);
  }

  applyForItems(dataForm) {
    return api.post('/merchant/voucher-apply-for-items', dataForm);
  }
}

export default new SettingVoucherService();
